import debounce from "lodash.debounce";
import { useCallback, useMemo, useState } from "react";
import { RxPlus } from "react-icons/rx";

import type { Option } from "@sorcery/db";
import { AsyncCombobox } from "@sorcery/ui";

import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import type { CardType } from "~/types/card";
import { api } from "~/utils/trpc";

export const DeckQuickAddInput = () => {
  const { openModal } = useModal();
  const [query, setQuery] = useState("");

  const { data, isFetching, isRefetching } = api.search.cards.useQuery(
    {
      query,
    },
    { enabled: !!query },
  );

  const queryChangeHandler = useCallback((q: string) => {
    setQuery(q);
  }, []);

  const debouncedChangeHandler = useMemo(
    () => debounce(queryChangeHandler, 500),
    [queryChangeHandler],
  );

  const onSelect = useCallback(
    (o: Option) => {
      openModal(ModalTypeEnum.DECKGALLERY, {
        card: o.data as CardType,
      });
    },
    [openModal],
  );

  return (
    <>
      <div className="flex items-center">
        <div className="mr-2 w-full max-w-sm">
          <AsyncCombobox
            placeholder="Quick add..."
            loading={isFetching && !isRefetching}
            onSelect={onSelect}
            query={query}
            setQuery={debouncedChangeHandler}
            options={data ?? []}
            icon={RxPlus}
            clearAfterSelect={true}
          />
        </div>
      </div>
    </>
  );
};
